export default __webpack_public_path__ + "static/media/chandan_h.751c8b45.png";